import VacationsAbsencesManager from 'common/domain/models/vacationsAbsencesManager';

class managerDataAssembler {
  static assemble(data) {
    let manager = new VacationsAbsencesManager();
    manager.employeesOutOffice = data.employeesOutOffice || [];
    manager.listRequestsEmployees = data.listRequestsEmployees || [];
    return manager;
  }
}

export default managerDataAssembler;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/managerRepository/managerRepository.assemblers.js